import Vue from "vue";
import "./plugins/vuetify";

import App from "./App.vue";
import router from "./router";
import store from "./store";

import VueTimeago from "vue-timeago";
import * as VueGoogleMaps from "vue2-google-maps";

import ApiService from "@/store/api-service";

import { MazPhoneNumberInput } from "maz-ui";

import { GOOGLE_API_KEY } from "../config";

Vue.config.productionTip = false;

Vue.use(VueTimeago, {
	name: "timeago", // component name, `timeago` by default
	locale: "en-US",
	locales: {}
});

Vue.use(MazPhoneNumberInput);

Vue.use(VueGoogleMaps, {
	load: {
		key: GOOGLE_API_KEY,
		libraries: "places" //necessary for places input
	}
});

ApiService.init();

// -------------------------------------------------------------------------------
// https://devblog.digimondo.io/building-a-simple-eventbus-in-vue-js-64b70fb90834
// -------------------------------------------------------------------------------
// Create a global Event Bus
let EventBus = new Vue();

// Add to Vue properties by exposing a getter for $bus
Object.defineProperties(Vue.prototype, {
	$bus: {
		get() {
			return EventBus;
		}
	}
});

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount("#app");
